import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";
import { useHistory, Link } from "react-router-dom";

const Register = () => {
  
  //console.log(POST_API)

  const userDataInit = {username:"",password:"",confirmPassword:""}

  const { enqueueSnackbar } = useSnackbar();
  const [userData,setUserData] = useState(userDataInit);
  const[loading,setLoading] = useState(false);
  const history = useHistory();
  let isValid = false;
 


  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */

   //handleInput funtion for input change event
   const handleInput = (e)=>{
     const key = e.target.name;
     const value = e.target.value;
     setUserData({...userData,[key]:value});
     //console.log("userData",userData)
   }

   //register function for submit the form
  const register = async (formData) => { 
  
    validateInput(formData)

    const POST_API = config['endpoint']+"/auth/register";
    const postData = {
      username:formData.username,
      password:formData.password,
    }
if (isValid===true){
    try {
    setLoading(true)
      let response = await axios.post(POST_API,postData);
      //console.log("formdata=",formData)
    // console.log("response",response.data)
    
        if(response.status===201){
          enqueueSnackbar("Registered successfully",{variant:"success"});
          setUserData(userDataInit);
        
        }
        setLoading(false);
        history.push("/login",{from:"Register"});
    } 
    catch (error) {
        //((error.response)? enqueueSnackbar(error.response.data.message,{ variant: "error" }):enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",{ variant: "warning" }))
        setLoading(false)
        if (error.response){
        //if(error.response.status ===400){
          enqueueSnackbar('Username is already taken',{ variant: "error" })
        //}
      }
      else{
      enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",{ variant: "warning" })

      }
    }
 };
}
   

        // const handleOnRegister = async () => {
        //  await register(userData)
        // }

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    if(data.username===""){
      enqueueSnackbar("Username is a required field",{ variant: "warning" })
      return isValid=false;
    }
    else if(data.username.length<6){
      enqueueSnackbar("Username must be at least 6 characters",{ variant: "warning" })
      return isValid=false;
    }
    else if(data.password ===""){
      enqueueSnackbar("Password is a required field",{ variant: "warning" })
      return isValid=false;
    }
    else if(data.password.length<6){
      enqueueSnackbar("Password must be at least 6 characters",{ variant: "warning" })
      return isValid=false;
    }
    else if(data.password !== data.confirmPassword){
      enqueueSnackbar("Passwords do not match",{ variant: "warning" })
      return isValid=false;
    }
    return isValid=true;
    
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            placeholder="Enter Username"
            fullWidth
            value={userData.username}
            onChange={handleInput}
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be atleast 6 characters length"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={userData.password}
            onChange={handleInput}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            fullWidth
            value={userData.confirmPassword}
            onChange={handleInput}
          />
         {/* //Display the progress bar for loading */}
          {loading?
          (<Box display="flex" justifyContent="center" alignItems="center"><CircularProgress size={25} color="primary"/></Box>)
          :
           (<Button className="button" variant="contained" onClick={async()=>await register(userData)}>
            Register Now 
           </Button>)}
          <p className="secondary-action">
            Already have an account?{" "}
             <Link  className="link" to="/login">
              Login here
             </Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
